import type { OdooObjectDto } from "../../../api";

const NEW_CONDITION = "new";

/**
 * The condition a product card must disclose before the buyer opens the
 * product — e.g. "Refurbished", or "New / Refurbished" when a template sells
 * both. `null` when everything is New (or unknown), since "New" is the
 * baseline a buyer already assumes and would only add noise to every card.
 */
export function getConditionLabel(
  conditions: (OdooObjectDto | null | undefined)[] | null | undefined,
): string | null {
  const names = (conditions ?? [])
    .map((condition) => condition?.name?.trim())
    .filter((name): name is string => Boolean(name));
  const hasNonNew = names.some((name) => name.toLowerCase() !== NEW_CONDITION);
  return hasNonNew ? names.join(" / ") : null;
}
